import React from 'react';
import moment from 'moment';
import ButtonAngleLeft from './ButtonAngleLeft';
import ButtonAngleRight from './ButtonAngleRight';

function YearSwitch({ minYear, currentYear, setYear }) {
    function getPrevYear() {
        return currentYear - 1;
    }

    function getNextYear() {
        return currentYear + 1;
    }

    function setNextYear() {
        setYear(getNextYear());
    }

    function setPrevYear() {
        setYear(getPrevYear());
    }

    function yearAvailable(year) {
        if (year > moment().year() || year < minYear) return false;
        return true;
    }

    return (
        <div className="text-center font-18">
            {yearAvailable(getPrevYear()) && <ButtonAngleLeft action={setPrevYear} />}
            <span className="m-2">{currentYear}</span>
            {yearAvailable(getNextYear()) && <ButtonAngleRight action={setNextYear} />}
        </div>
    );
}

export default YearSwitch;
